// src/components/store/sections/newsletter/NewsletterV42CathedralinviteCoralFlame.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV42CathedralinviteCoralFlame(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={42}
      archKey="cathedral_invite"
      archLabel="Cathedral Arch Invite"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
